// extracted by mini-css-extract-plugin
export default {"sectionContainer":"sustainability_sectionContainer__BQPya"};